<mat-progress-bar *ngIf="isLoading && messages.length === 0" mode="indeterminate"></mat-progress-bar>
<div class="login-container check-flex-col check-justify-center check-items-center">
  <div class="white-box-container">
    <div class="login-header check-flex-col check-space-evenly check-items-center">
      <img src="../../../../assets/img/icons/logos/logo.png"/>
      <h1 class="title-spacing"><a routerLink="/{{CommonRoutes.LOGIN}}">Il Portale del Cantiere</a></h1>
      <h2>Associazione Account Esterno</h2>
      <p *ngIf="externalService" class="service-name subtitle-spacing">
        Servizio: <strong>{{externalService}}</strong>
      </p>
    </div>

    <div *ngIf="messages.length > 0" class="messages-container">
      <app-alert-messages-box
        class="w-full"
        [messages]="messages">
      </app-alert-messages-box>
    </div>

    <form
      *ngIf="!associationComplete && !isAssociating && hasValidParameters()"
      [formGroup]="loginForm"
      class="login-form check-flex-col">

      <p class="info-text">
        Per completare l'associazione, accedi con il tuo account Check:
      </p>

      <label>Username</label>
      <mat-form-field appearance="outline">
        <input autocomplete="off" formControlName="username" matInput type="text" />
      </mat-form-field>

      <label>Password</label>
      <mat-form-field appearance="outline">
        <input autocomplete="off" formControlName="password" matInput type="password" />
      </mat-form-field>

      <mat-error class="login-error" *ngIf="loginError$ | async as error">{{ error }}</mat-error>

      <div class="w-full check-flex-row check-space-between check-items-center">
        <app-request-password-link class="check-flex check-items-center"></app-request-password-link>
        <button
          color="primary"
          mat-flat-button
          (click)="login()"
          [disabled]="isLoading">
          Accedi e Associa
        </button>
      </div>
    </form>

    <div
      *ngIf="isAssociating && !associationComplete"
      class="login-form check-flex-col check-items-center">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="message-spacing">Associazione in corso...</p>
    </div>

    <div
      *ngIf="associationComplete"
      class="login-form check-flex-col check-items-center">
      <p class="success-subtitle subtitle-spacing">
        Puoi chiudere questa pagina.
      </p>
    </div>

    <div
      *ngIf="!hasValidParameters() && messages.length === 0"
      class="login-form">
      <p class="error-text">
        Link non valido. Assicurati di utilizzare il link fornito dal servizio esterno.
      </p>
    </div>
  </div>
</div>
